const ICON_DEFAULT_PATH = "/wp-content/plugins/pottsalat/static/images/icons";
const IMAGE_DEFAULT_PATH = "/wp-content/plugins/pottsalat/static/images";

const concatPath = (base, asset) => base + `/${asset}`;

export const getSvgIcon = (icon) => {
    if (typeof reactConfig === "undefined" || !reactConfig) {
        return concatPath(ICON_DEFAULT_PATH, icon);
    }

    return concatPath(reactConfig?.iconPath, icon);
};

export const getImageAsset = (asset) => {
    return concatPath(IMAGE_DEFAULT_PATH, asset);
};
